import React, { useMemo, useEffect } from 'react';
import { useCollect } from 'hooks';

import Container from 'components/Misc/Container';
import { Input, Select } from 'components/Misc/Form';

const Search = ({ search, onChange }) => {
	// Store subject request parameters
	const parameters = useMemo(() => ({
		eager: 'courses',
	}), []);

	// Store requested subjects
	const [[subjects], collect] = useCollect('subjects', parameters);

	// Store courses based on collected subjects
	const courses = useMemo(() => {
		// Filter courses only if subject is selected
		if (!search.subjectId) return [];

		// Filter out selected subject's courses
		return subjects?.find(subject => subject.id === +search.subjectId)?.courses;
	}, [search.subjectId, subjects]);

	// Collect subjects on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	return (
		<Container className="mt-4 p-4 flex gap-4">
			<Input
				type="text"
				name="name"
				placeholder="Vārds, Uzvārds"
				value={search.name}
				onChange={onChange}
			/>

			<Select
				name="subjectId"
				placeholder="Mācību kurss"
				value={search.subjectId}
				onChange={onChange}
				options={subjects?.map(subject => ({
					value: subject.id,
					name: subject.title
				}))}
			/>

			<Select
				name="courseId"
				placeholder="Mācību modulis"
				disabled={!courses?.length}
				value={search.courseId}
				onChange={onChange}
				options={courses?.map(course => ({
					value: course.id,
					name: course.title
				}))}
			/>

			<Select
				name="state"
				placeholder="Pārbaudes darba statuss"
				value={search.state}
				onChange={onChange}
				options={[
					{ value: 'active', name: 'Tiek pildīts' },
					{ value: 'finished', name: 'Iesniegts' },
					{ value: 'reviewed', name: 'Izvērtēts' },
					{ value: 'failed', name: 'Nesekmīgs' },
					{ value: 'missed', name: 'Nokavēts' }
				]}
			/>
		</Container>
	);
};

export default Search;